import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

enum Flow {
  Onboarding = 'onboarding',
  GtmSetup = 'gtm_setup'
}

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})

export class HomepageComponent implements OnInit {
  private flowParamKey = 'flow';

  constructor(private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    const hasParams = !!Object.keys(params).length;

    // if there are no params, the preload component will handle things
    if (!hasParams) {
      return;
    }

    if (this.flowParamKey in params) {
      this.routeOnFlow(params[this.flowParamKey], params);
      return;
    }

    this.router.navigate(['accounts'], { queryParams: params });
  }

  private routeOnFlow(flow: string, params: Params): void {
    switch (flow) {
      case Flow.Onboarding:
        this.router.navigate(['/onboarding'], { queryParams: params });
        return;
      case Flow.GtmSetup:
        this.router.navigate(['/gtm-setup'], { queryParams: params });
        return;
    }
  }
}
